module.exports = __webpack_public_path__ + "408f115262aedc5e3e8d307d41e69077.pdf";